(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('skeletonStyledInput', {
            templateUrl: 'app/components/skeleton/styled-input/skeleton-styled-input.html',
            controller: skeletonFieldController,
            bindings: {
                label: '@',
                inputElement: '@',
                inputClass: '@'
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function skeletonFieldController() {
        var vm = this;
        vm.$onInit = init;

        function init() {
            vm.inputElement = vm.inputElement || 'input';
            vm.inputClass = vm.inputClass || 'form-control';
        }
    }
})();
